var _effectorFileName = "/builds/gmini/front-ism-api-sdk/src/IssueStatus.ts";
import * as t from 'io-ts';
import { ApiCallService } from '@gmini/api-call-service';
import { ApiDomain } from './domain';
export var IssueStatus;
(function (_IssueStatus) {
  var domain = ApiDomain.domain('IssueStatus', {
    name: "domain",
    sid: "-oic1fb"
  });
  var Enum;
  (function (Enum) {
    Enum["DRAFT"] = "DRAFT";
    Enum["IN_PROCESS"] = "IN_PROCESS";
    Enum["ON_REVIEW"] = "ON_REVIEW";
    Enum["NOT_STARTED"] = "NOT_STARTED";
    Enum["CLOSED"] = "CLOSED";
    Enum["NOT_RELEVANT"] = "NOT_RELEVANT";
  })(Enum || (Enum = {}));
  _IssueStatus.Enum = Enum;
  var io = _IssueStatus.io = t.union([t.literal(Enum.CLOSED), t.literal(Enum.DRAFT), t.literal(Enum.IN_PROCESS), t.literal(Enum.NOT_STARTED), t.literal(Enum.ON_REVIEW), t.literal(Enum.NOT_RELEVANT)]);
  var Data = _IssueStatus.Data = t.type({
    name: t.string,
    status: io
  });
  var fetchList = _IssueStatus.fetchList = ApiCallService.create({
    name: 'fetchList',
    parentDomain: domain,
    result: t.array(Data),
    getKey: function getKey() {
      return '0';
    }
  });
})(IssueStatus || (IssueStatus = {}));